import * as React from "react";
import { useTranslation } from "react-i18next";
import { DocumentTitle, PageHeader } from "components/common";
import AgentWorkflowPageNavigation from "aiagent/AgentWorkflowPageNavigation";
import AgentWorkflowUsage from "aiagent/AgentWorkflowUsage/AgentWorkflowUsage";
const AgentWorkflowUsagePage = () => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("usage_page.document_title") }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: t("token_usage_page.title") }, /* @__PURE__ */ React.createElement("span", null, t("usage_page.description"))), /* @__PURE__ */ React.createElement(AgentWorkflowUsage, null));
};
export default AgentWorkflowUsagePage;
